import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';
import RecipientDragData from '../store/schema/RecipientDragData';
import { observer } from 'mobx-react';
import Droppable from 'owa-dnd/lib/components/Droppable';
import DropViewState from 'owa-dnd/lib/store/schema/DropViewState';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import * as React from 'react';

export interface DroppableWellProps {
    dropViewState: DropViewState;
    addRecipientAction: (recipientToAdd: ReadWriteRecipientViewState) => void;
}

@observer
export default class DroppableWell extends React.Component<DroppableWellProps, any> {
    render() {
        return (
            <Droppable
                dropViewState={this.props.dropViewState}
                canDrop={this.canDrop}
                onDrop={this.onDrop}>
                {this.props.children}
            </Droppable>
        );
    }

    private canDrop(dragData: DragData): boolean {
        return dragData.itemType === DraggableItemTypes.ReadWriteRecipient;
    }

    private onDrop = (
        dragData: RecipientDragData,
        pageX: number,
        pageY: number,
        target?: HTMLElement
    ): void => {
        if (this.canDrop(dragData)) {
            let recipient = dragData.recipientViewState;
            this.props.addRecipientAction(recipient);
        }
    };
}
